module.exports = __webpack_public_path__ + "static/media/cq_editor_testo_destra b.dd8755c3.svg";